export default __webpack_public_path__ + "images/00f5b084c8bd30b61b4b8be4c34f35da-doc.svg";